/**
 * @description Type of form field, e.g. text, number, checkbox.
 */
export enum InputType {
  Text = 'Text',
  Number = 'Number',
  OptionList = 'OptionList',
  CheckBox = 'CheckBox',
  Date = 'Date',
  Hidden = 'Hidden',
  Password = 'Password',
  Tel = 'Tel',
  Toggle = 'Toggle',
  Email = 'Email',
  Country = 'Country',
  Boolean = 'Boolean',
  Loqate = "loqate",

  // MyRIA
  searchableSelect = 'searchableSelect',
  phoneNumber = 'phoneNumber'
}


// WEBPACK FOOTER //
// ./src/providers/formbuilder/input-type.ts